import styled from '@emotion/styled';
import { breakpoint, colors, spacing, typography } from '../../../../../themes';

export const FileUploadBoxContainer = styled.div<{ hasError: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 22;
  border: 2px ${(props) => (props.hasError ? 'solid' : 'dashed')} ${colors.monochrome.grey40};
  border-radius: 5px;
  padding: ${spacing.mediumLow};
  border-color: ${(props) => {
    return props.hasError ? colors.alerts.error : colors.monochrome.grey40;
  }};
`;

export const FileUploadBrowse = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing.xmsmall};
  flex-wrap: wrap;

  @media (max-width: ${breakpoint.small}px) {
    justify-content: center;
  }
`;

export const FileUploadBrowseSubTitle = styled.div`
  ${typography.body.small}
  color: ${colors.primary.grey};

  text-align: center;
  display: flex;
  flex-direction: column;
  gap: ${spacing.xxsmall};
`;

export const FileUploadBrowseTitle = styled.div`
  display: flex;
  ${typography.other.inputLabel}
  color: ${colors.primary.grey};
`;

export const FileUploadInnerBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xxsmall};
`;
